import type { Action } from 'redux'
import type { EnableRegionsRes, RegionsDataRes } from '@/types/api'
import { Currency, SecondaryCurrency } from '@/utils/currency'
import { Language } from '@/utils/language'
import { Region } from '@/utils/region'

const actionTypes = {
  updateSsrStore: Symbol('updateSsrStore')
}

export const actions = {
  updateSsrStoreAction: (payload: Partial<typeof initialState>) => ({
    type: actionTypes.updateSsrStore,
    payload
  })
}

export const initialState = {
  lang: Language.enUS,
  currency: Currency.US,
  region: Region.US,
  secondaryCurrency: SecondaryCurrency.CN,
  token: '',
  dataUpdateTime: 0,
  regionsData: {} as RegionsDataRes,
  enableRegions: [] as EnableRegionsRes,
  isMobile: false,
  host: '',
  showMemberModal: false,
  memberModalClosable: true,
  ua: ''
}

export default function reducer(
  state = initialState,
  action: Action<symbol> & { payload: Partial<typeof initialState> }
) {
  switch (action.type) {
    case actionTypes.updateSsrStore: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}
